import { ICountChartData } from './chart.models';

export enum AgeGroups {
  'ADULT' = 'ADULT',
  'MINOR' = 'MINOR',
}

export enum Races {
  'BLACK' = 'BLACK',
  'ASIAN_PACIFIC_ISLANDER' = 'ASIAN_PACIFIC_ISLANDER',
  'WHITE' = 'WHITE',
  'HISPANIC_LATINO' = 'HISPANIC_LATINO',
  'ALASKA_NATIVE_AMERICAN_INDIAN' = 'ALASKA_NATIVE_AMERICAN_INDIAN',
}

export type IGenerateRaceDataFuncResult = {
  total: { label: Races; value: number }[];
  filtered: { label: Races; value: number }[];
  labels: Races[];
};

export type IPersonsChartsData = Partial<Record<string, ICountChartData>>;

export type IGenerateRaceDataFunc = () => IGenerateRaceDataFuncResult;
